import { Rule } from "antd/es/form";
import {
  regexPhoneNumber,
  regexpInn,
  regexpInnOrganisation,
  regexpInnUser,
  regexpNumberLot,
  regexpSumm,
} from "../RegexpConstants";
import { ValidateFormErrorMessages } from "../validateFormErrorMessages";
import { PHONE_NUMBER_PATTERN } from "../regexp/PhoneNumberRegexp";

export const ruleSummMinMax: Rule = {
  pattern: regexpSumm,
  message: "Сумма от 0 и до 100 млрд",
};

export const ruleRequired: Rule = {
  required: true,
  message: ValidateFormErrorMessages.required,
};

export const rulePhoneLength: Rule = {
  max: 12,
  message: "Номер телефона должен содержать не больше 12 символов",
};

export const rulePhoneWithMaskLength: Rule = {
  max: 16,
  message: "Номер телефона должен содержать не больше 12 символов",
};

export const rulePhoneFormat: Rule = {
  pattern: regexPhoneNumber,
  message: ValidateFormErrorMessages.phoneFormatMessage,
};

export const ruleInnOrgsnisation: Rule = {
  pattern: regexpInnOrganisation,
  message: "Введите существующий ИНН длиной в 10 символов",
};

export const ruleInnUser: Rule = {
  pattern: regexpInnUser,
  message: "Введите существующий ИНН длиной в 12 символов",
};

export const ruleInn: Rule = {
  pattern: regexpInn,
  message: "Введите существующий ИНН",
};

export const ruleText: Rule = {
  max: 200,
  message: "Не должно быть больше 200 символов",
};

export const ruleBankName: Rule = {
  max: 200,
  message: "Наименование банка не должно быть больше 200 символов",
};

export const ruleNumberLot: Rule = {
  pattern: regexpNumberLot,
  message: "Введите значение от 1 до 999",
};

export const ruleEmailVtorf = {
  pattern: /^[a-z0-9._%+-]+@vtorf\.(ru|pro)$/i,
  message: "Введите адрес с домена vtorf.ru или vtorf.pro",
};

export const ruleFormatPhoneNumber = {
  pattern: PHONE_NUMBER_PATTERN,
  message: "Номер телефона должен быть в формате: +7 999 999 99 99",
};
